// CONSTANTS FOR MOBILE VIEW
export const MOBILE_WIDTH_HIGH = 1000
